import { render, staticRenderFns } from "./KeywordsSearchConsole.vue?vue&type=template&id=67b963f8&scoped=true"
import script from "./KeywordsSearchConsole.vue?vue&type=script&lang=js"
export * from "./KeywordsSearchConsole.vue?vue&type=script&lang=js"
import style0 from "./KeywordsSearchConsole.vue?vue&type=style&index=0&id=67b963f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b963f8",
  null
  
)

export default component.exports